<template>
  <div id="user-list">
    <!-- app drawer -->
    <v-dialog
      v-model="isFormActive"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <genre-form
        v-model="item"
        v-if="isFormActive"
        :is-form-active="isFormActive"
        @refetch-data="fetchItems"
      >
        <template v-slot:form-title>
          <span
            class="font-weight-semibold text-base text--primary">{{ item.id ? $t('Modifier') : $t('Ajouter un genre')
            }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isFormActive = !isFormActive"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </template>
        <template #form-cancel>
          <v-btn
            :loading="loading"
            color="secondary"
            outlined
            type="reset"
            @click="isFormActive = !isFormActive"
          >
            {{ $t('Annuler') }}
          </v-btn>
        </template>
      </genre-form>
    </v-dialog>
    <!-- genre total card -->

    <!-- list filters -->
    <v-card class="mb-3">
      <div>
        <v-breadcrumbs
          :items="itemsBreadcrumbs"
          divider=">"
        >
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              :disabled="item.disabled"
              @click="goToParent(item)"
            >
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </div>
    </v-card>
    <v-card>
      <v-card-title>
        {{ $t('Genres') }}
        <v-chip outlined class="ml-2">{{ totalItems }}</v-chip>
      </v-card-title>
      <v-divider class="mt-4"></v-divider>

      <!-- actions -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <!-- search -->
        <v-text-field
          v-model="searchQuery"
          :placeholder="$t('Rechercher')"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
        >
        </v-text-field>

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            color="primary"
            class="mb-4 me-3"
            @click.stop="openDialog(false)"
          >
            <v-icon>{{ icons.mdiPlus }}</v-icon>
            <span>{{ $t('Ajouter un Genre') }}</span>
          </v-btn>

          <!--          <v-btn
            color="secondary"
            outlined
            class="mb-4"
          >
            <v-icon
              size="17"
              class="me-1"
            >
              {{ icons.mdiExportVariant }}
            </v-icon>
            <span>Export</span>
          </v-btn>-->
        </div>
      </v-card-text>

      <!-- table -->
      <v-data-table
        v-model="selectedRows"
        class="fixed-table"
        dense
        :headers="tableColumns"
        :items="items"
        :options.sync="options"
        :page.sync="page"
        :server-items-length="totalItems"
        :loading="loading"
        hide-default-footer
        show-select
        :loading-text="$t('Chargement des éléments')"
        :no-data-text="$t('Pas de données')"
        :no-results-text="$t('Aucun résultat')"
        @page-count="pageCount = $event"
      >
        <!-- tarification -->
        <template #[`item.pricing_table`]="{item}">
          <span v-if="item.pricing_table">
            {{ item.pricing_table.Label }}
            <v-icon
              v-if="parsePricing(item.pricing_table.pricing)"
              small
              class="ml-1"
              color="info"
              style="cursor: pointer;"
              @click.stop="openPricingDialog(item)"
            >{{ icons.mdiInformation }}</v-icon>
          </span>
        </template>

        <!-- actions -->
        <template #[`item.actions`]="{item}">
          <v-btn
            icon
            small
            v-if="item.children.length > 0"
          >
            <v-icon
              size="20"
              @click="loadChildren(item)"
            >
              {{ icons.mdiMagnifyPlus }}
            </v-icon>
          </v-btn>
          <v-btn
            icon
            small
          >
            <v-icon
              size="20"
              @click="openDialog(item)"
            >
              {{ icons.mdiPencilOutline }}
            </v-icon>
          </v-btn>
          <v-btn
            icon
            small
            color="error"
          >
            <v-icon
              size="20"
              color="error"
              @click="confirmDelete(item)"
            >
              {{ icons.mdiDeleteOutline }}
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <rows-per-page :options="options" />
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="page"
              total-visible="6"
              :length="pageCount"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 300 : '100%'"
    >
      <v-card>
        <v-card-title>{{ $t('Confirmer la suppression') }}</v-card-title>
        <v-divider />
        <v-card-text>{{ $t('Confirmez-vous de vouloir supprimer') }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            small
            outlined
            @click="deleteDialog = false"
          >
            {{ $t('Non') }}
          </v-btn>
          <v-spacer />
          <v-btn
            small
            color="primary"
            @click="deleteItem"
          >
            {{ $t('Oui') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- pricing table dialog -->
    <v-dialog
      v-model="pricingDialog"
      max-width="720"
      scrollable
    >
      <v-card v-if="pricingDialogGenre && pricingDialogGenre.pricing_table">
        <v-card-title class="d-flex align-center py-3">
          <span class="text-base font-weight-semibold">
            {{ $t('Table de tarification assignée à') }} {{ pricingDialogGenre.label }}
          </span>
          <v-spacer />
          <v-btn
            icon
            small
            @click="pricingDialog = false"
          >
            <v-icon size="22">{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="pa-4"
          style="max-height: 60vh; overflow-y: auto;"
        >
          <template v-if="Array.isArray(parsePricing(pricingDialogGenre.pricing_table.pricing))">
            <table class="pricing-popup-table">
              <thead>
                <tr>
                  <th
                    v-for="col in Object.keys(parsePricing(pricingDialogGenre.pricing_table.pricing)[0] || {})"
                    :key="col"
                  >{{ col }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, i) in sortByPageMin(parsePricing(pricingDialogGenre.pricing_table.pricing))"
                  :key="i"
                >
                  <td
                    v-for="col in Object.keys(row)"
                    :key="col"
                  >{{ formatPricingValue(col, row[col]) }}</td>
                </tr>
              </tbody>
            </table>
          </template>
          <template v-else>
            <table class="pricing-popup-table">
              <tbody>
                <tr
                  v-for="(val, key) in parsePricing(pricingDialogGenre.pricing_table.pricing)"
                  :key="key"
                >
                  <td class="font-weight-medium key-col">{{ key }}</td>
                  <td>{{ formatPricingValue(key, val) }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="isSnackbarBottomVisible"
      :color="$vuetify.theme.currentTheme.error"
      :light="$vuetify.theme.dark"
    >
      {{ snackBarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiEye,
  mdiMagnifyPlus,
  mdiSquareEditOutline,
  mdiDotsVertical,
  mdiPlus,
  mdiClose,
  mdiFileDocumentOutline,
  mdiDeleteOutline,
  mdiExportVariant,
  mdiAccountOutline,
  mdiPencilOutline,
  mdiInformation,
} from '@mdi/js'
import { ref, onMounted, onUnmounted } from '@vue/composition-api'

// sidebar
import { avatarText } from '@core/utils/filter'
import store from '@/store'
import GenreForm from './GenreForm.vue'
import userStoreModule from './itemStoreModule'

import controller from './Controller'
import RowsPerPage from '@/components/RowsPerPage'

export default {
  components: {
    RowsPerPage,
    GenreForm,
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'genre'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    const parsePricing = pricing => {
      if (!pricing) return null
      if (typeof pricing === 'string') {
        try { return JSON.parse(pricing) } catch (e) { return null }
      }
      return pricing
    }

    const MONETARY_KEYS = ['frais']

    const formatPricingValue = (key, val) => {
      if (val === null || val === undefined) return '—'
      const num = parseFloat(val)
      if (!isNaN(num)) {
        const formatted = Number.isInteger(num) ? String(num) : num.toFixed(2)
        return MONETARY_KEYS.includes(key) ? `${formatted} €` : formatted
      }
      return val
    }

    const sortByPageMin = rows => {
      if (!Array.isArray(rows)) return rows
      return [...rows].sort((a, b) => {
        const findVal = obj => {
          const key = Object.keys(obj).find(k => k.toLowerCase() === 'page_min')
          return key !== undefined ? parseFloat(obj[key]) || 0 : 0
        }
        return findVal(a) - findVal(b)
      })
    }

    const pricingDialog = ref(false)
    const pricingDialogGenre = ref(null)
    const openPricingDialog = genreItem => {
      pricingDialogGenre.value = genreItem
      pricingDialog.value = true
    }

    const goToParent = (item) => {
      if (item.disabled) return

      fetchItems(item.id_parent, true)
    }

    onMounted(() => {
      // eslint-disable-next-line no-use-before-define
      fetchItems()
    })

    const {
      item,
      items,
      tableColumns,
      searchQuery,
      totalItems,
      loading,
      options,
      selectedRows,
      isFormActive,
      snackBarMessage,
      isSnackbarBottomVisible,
      openDialog,
      itemsBreadcrumbs,
      loadChildren,
      deleteItem,
      confirmDelete,
      deleteDialog,
      fetchItems,
    } = controller()

    return {
      item,
      items,
      tableColumns,
      searchQuery,
      totalItems,
      loading,
      options,
      isFormActive,
      selectedRows,
      snackBarMessage,
      isSnackbarBottomVisible,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      deleteDialog,
      confirmDelete,
      openDialog,
      loadChildren,
      deleteItem,
      avatarText,
      fetchItems,
      itemsBreadcrumbs,
      goToParent,
      parsePricing,
      formatPricingValue,
      sortByPageMin,
      pricingDialog,
      pricingDialogGenre,
      openPricingDialog,

      // icons
      icons: {
        mdiEye,
        mdiMagnifyPlus,
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiClose,
        mdiExportVariant,
        mdiAccountOutline,
        mdiPencilOutline,
        mdiInformation,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.pricing-popup-table {
  border-collapse: collapse;
  font-size: 0.85rem;
  width: 100%;

  th,
  td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 6px 16px;
    text-align: right;
    white-space: nowrap;
  }

  th {
    font-weight: 600;
    background: rgba(0, 0, 0, 0.04);
    text-transform: capitalize;
  }

  td.key-col {
    text-align: left;
  }

  tbody tr:nth-child(even) td {
    background: rgba(0, 0, 0, 0.02);
  }

  tbody tr:hover td {
    background: rgba(0, 0, 0, 0.06);
  }
}
</style>
